import ULThemeSeparator from "@/components/ULThemeSeparator";
import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaPushList from "./components/MfaPushList";
import MfaPushListHeader from "./components/MfaPushListHeader";
import { useMfaPushListManager } from "./hooks/useMfaPushListManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaPushListScreen() {
    // Extracting attributes from hook made out of MfaPushList instance of Auth0 React ACUL SDK
    const { texts, locales, mfaPushListInstance } = useMfaPushListManager();

    applyAuth0Theme(mfaPushListInstance);
    return (
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <MfaPushListHeader />
            <ULThemeSeparator className="grow-0" />
            <MfaPushList />

        </AuthLayout>
    );
}

export default MfaPushListScreen;
